import React from 'react';
import { Link } from 'react-router-dom';

import ContactInfo from '../../components/shared/ContactInfo';

const ClearanceFail = ({ formData, resetClearance }) => (
    <div className="container" id="failClearance">
        <div className="row">
            <div className="com-xs-12">
                <h1>This Submission Did Not Pass Clearance.</h1>
                <h4 className="non-fat">
                    Your business as listed below matches a previously processed submission.
                    “Already received clearance? Check the Submissions page and update from there!”
                </h4>
                <div>
                    <div className="common-notification info pull-left width_100 mbottom_20">
                        <p className="sub-header-firstRow">Sent to an underwriter for review</p>
                        <ContactInfo />
                    </div>
                    <div className="mt-x2">
                        <h4>First Named Insured:</h4>
                        <h5 className="non-fat">{formData.primaryInsuredName}</h5>
                        <hr />
                        <h4>Project Address:</h4>
                        <address>
                            <small className="text-muted">First Name Insured</small>
                            <br />
                            {formData.projectAddress.projectAddress} <br />
                            {formData.projectAddress.projectCity}{' '}
                            {formData.projectAddress.projectState}{' '}
                            {formData.projectAddress.projectZipcode}
                            <br />
                        </address>
                        <hr />
                    </div>
                </div>
            </div>

            <button className="btn btn-primary mbottom_20" onClick={resetClearance}>
                Re-enter Clearance Information
            </button>
            <Link to="/submissions" className="btn btn-link mbottom_20">
                Return to Submissions
            </Link>
        </div>
    </div>
);
export default ClearanceFail;
